import {Project, SeasonalSeriesType, SeriesType, Site} from 'src/lib/api/project';
import {DashboardSection} from 'src/lib/api/series';

/**
 * The sections whose dashboard component reads from H5: everything customer-visible, plus, while
 * previewing, everything H5 has a publication for at this site. Publications are per site, so a
 * preview at one site says nothing about its neighbours in the same project.
 */
export function h5DashboardSectionsFor(
  project: Pick<Project, 'customerVisibleDashboardSections'>,
  site: Pick<Site, 'h5Sections'>,
  preview: boolean
): Set<DashboardSection> {
  return new Set([
    ...(project.customerVisibleDashboardSections ?? []),
    ...(preview ? (site.h5Sections ?? []) : []),
  ]);
}

// The series type the legacy Seasonal component draws, or undefined when H5 already draws every
// seasonal series the site has. The rolling series is preferred, as on a site without H5; a series
// whose section H5 draws is skipped so the same forecasts never show twice.
export function legacySeasonalSeriesTypeFor(
  site: Pick<Site, 'seriesTypes'>,
  h5DashboardSections: Set<DashboardSection>
): SeasonalSeriesType | undefined {
  if (
    site.seriesTypes.includes(SeriesType.FlowSeasonalRolling) &&
    !h5DashboardSections.has(DashboardSection.Seasonal)
  ) {
    return SeriesType.FlowSeasonalRolling;
  }
  if (
    site.seriesTypes.includes(SeriesType.FlowSeasonalRollingExtended) &&
    !h5DashboardSections.has(DashboardSection.Annual)
  ) {
    return SeriesType.FlowSeasonalRollingExtended;
  }
  return undefined;
}
